export const SERVICES = {
  it: {
    seo: {
      title: "Gestione professionale affitti brevi in Ogliastra | OGStay",
      description:
        "Servizi per la tua casa vacanza: ottimizzazione annunci, home staging, fotografia, revenue management e gestione completa in Ogliastra — molti disponibili da remoto in tutta Italia. Richiedi una valutazione gratuita.",
    },
    hero: {
      eyebrow: "Per i proprietari",
      h1a: "La tua casa può rendere di più.",
      h1b: "Senza diventare un secondo lavoro.",
      sub: "Gestiamo e valorizziamo case vacanza in Ogliastra. E mettiamo la nostra esperienza a disposizione dei proprietari in tutta Italia attraverso servizi professionali dedicati.",
      lines: ["Presenza reale in Ogliastra.", "Controllo totale.", "Un unico team che coordina tutto."],
      cta: "Affida la gestione",
      ctaSecondary: "Scopri i servizi singoli",
      trust: ["Prima chiamata conoscitiva gratuita di 15 minuti", "Nessun impegno"],
    },
    quiz: {
      title: "Partiamo dalla tua casa.",
      sub: "Tre domande, trenta secondi.",
      questions: [
        { q: "Dove si trova il tuo immobile?", options: ["Tortolì", "Arbatax", "Cardedu", "Bari Sardo", "Altro"] },
        { q: "Che tipo di proprietà è?", options: ["Villa", "Casa indipendente", "Appartamento", "Residence", "Struttura ricettiva", "Altro"] },
        { q: "È già online?", options: ["Sì", "No", "In parte"] },
      ],
      done: "Perfetto. Abbiamo già le prime informazioni per capire il potenziale della tua proprietà.",
      cta: "Continua la valutazione",
      step: "Domanda",
    },
    pains: {
      title: "Una casa vacanza non si gestisce più nel tempo libero.",
      items: [
        { tag: "Prezzi", headline: "Quanto stai perdendo nei giorni sbagliati?", text: "Una tariffa troppo alta lascia vuoti. Una troppo bassa regala margine." },
        { tag: "Ospiti", headline: "Chi risponde alle 23:40?", text: "Richieste, problemi, recensioni e imprevisti non seguono gli orari d'ufficio." },
        { tag: "Operatività", headline: "Chi controlla che tutto sia davvero pronto?", text: "Pulizie, lavanderia, manutenzione, dotazioni e check-in devono funzionare come un unico sistema." },
        { tag: "Normativa", headline: "Sei sicuro che il setup sia corretto?", text: "Inquadramento, CIN, ospiti, tassa di soggiorno, documenti e procedure richiedono attenzione." },
      ],
      closing: "OGStay coordina tutto questo come un unico sistema.",
    },
    method: {
      eyebrow: "Il metodo OGStay",
      title: "Non prendiamo semplicemente in gestione una casa.",
      titleItalic: "Costruiamo un prodotto hospitality.",
      steps: [
        { n: "01", t: "Analizziamo", items: ["immobile", "zona", "concorrenza", "domanda", "target", "potenziale"] },
        { n: "02", t: "Valorizziamo", items: ["home staging", "dotazioni", "comfort", "layout", "presentazione"] },
        { n: "03", t: "Posizioniamo", items: ["fotografia", "copywriting", "annunci", "canali", "branding"] },
        { n: "04", t: "Vendiamo", items: ["revenue management", "pricing dinamico", "occupazione", "restrizioni", "distribuzione"] },
        { n: "05", t: "Gestiamo", items: ["ospiti", "housekeeping", "check-in", "manutenzioni", "assistenza"] },
        { n: "06", t: "Misuriamo", items: ["ADR", "occupazione", "ricavi", "performance", "report", "ottimizzazione"] },
      ],
    },
    hotel: {
      eyebrow: "Alta hôtellerie, casa privata",
      title: "La libertà di una casa. Gli standard di un grande hotel.",
      text: "Non vogliamo trasformare una casa in un hotel. Prendiamo dall'hôtellerie ciò che fa davvero la differenza: standard, procedure, comfort, cura e attenzione al dettaglio.",
      standards: [
        { t: "Sleep", d: "Materassi, cuscini, biancheria e comfort." },
        { t: "Clean", d: "Housekeeping e controllo qualità." },
        { t: "Welcome", d: "Primo impatto, amenities e preparazione." },
        { t: "Design", d: "Ordine visivo e percezione di valore." },
        { t: "Care", d: "Manutenzione e tutela dell'immobile." },
        { t: "Guest", d: "Assistenza e customer experience." },
      ],
      closing: "Case di qualità attirano ospiti di qualità.",
    },
    staging: {
      title: "Non serve spendere tanto. Serve investire nei dettagli giusti.",
      text1: "Analizziamo cosa aumenta realmente la percezione di valore della proprietà.",
      text2: "Non riempiamo gli ambienti di mobili. Selezioniamo pochi interventi ad alto impatto su comfort, fotografia e desiderabilità.",
      highlight: "Pochi interventi. Scelti bene. Alto impatto.",
      before: "Prima",
      after: "Dopo",
      demo: "Intervento reale OGStay · home staging e valorizzazione",
    },
    buro: {
      eyebrow: "Dall'immobile alla struttura pronta a lavorare",
      title: "Tu hai la casa. Noi costruiamo il sistema intorno.",
      text: "Ti supportiamo nell'avviamento e nella configurazione operativa della struttura, in base al suo inquadramento.",
      items: [
        "Analisi della situazione iniziale",
        "Supporto all'inquadramento corretto",
        "CIN",
        "Configurazione PMS",
        "Guest Portal",
        "Portali istituzionali",
        "Registrazione ospiti",
        "Flussi ISTAT",
        "Tassa di soggiorno",
        "Contratti",
        "Airbnb e Booking",
        "Channel manager",
        "Automazioni",
        "Portale proprietari",
      ],
      note: "Gli adempimenti variano in base alla tipologia di struttura e alla situazione del proprietario.",
      cta: "Verifica il setup della tua struttura",
    },
    mandate: {
      eyebrow: "Un modello di gestione strutturato",
      title: "Non conta soltanto quanto incassa la casa. Conta quanto rimane al proprietario.",
      p1: "OGStay può operare tramite mandato con rappresentanza, con una gestione trasparente delle diverse componenti economiche della prenotazione.",
      p2: "Quando contratto, canale di vendita e inquadramento fiscale lo consentono, alcune voci di servizio possono essere gestite separatamente dal canone di locazione e addebitate direttamente all'ospite.",
      highlight: "Più trasparenza. Meno inefficienze. Maggiore attenzione al netto.",
      note: "Ogni situazione fiscale viene analizzata individualmente. Le simulazioni hanno finalità informative e devono essere validate sul caso concreto con il proprio consulente fiscale.",
    },
    calc: {
      title: "Quanto vale davvero una prenotazione?",
      stay: "Valore soggiorno",
      cleaning: "Pulizie",
      channel: "Canale",
      channels: ["Airbnb", "Booking", "Diretto"],
      tax: "Aliquota indicativa",
      mgmt: "Commissione gestione",
      traditional: "Gestione tradizionale",
      ogstay: "Modello OGStay",
      rows: {
        guest: "Incasso ospite",
        ota: "Commissione canale",
        cleaning: "Pulizie",
        mgmt: "Gestione",
        base: "Base imponibile indicativa",
        tax: "Imposte stimate",
        net: "Netto indicativo",
      },
      disclaimer: "Simulazione a scopo informativo, non un calcolo fiscale. Ogni caso va validato con il proprio consulente.",
      seasonIntro: "Ma una singola prenotazione racconta solo una parte della storia.",
      seasonFormula: "ADR × occupazione × giorni disponibili",
      seasonNote: "Il vero obiettivo è massimizzare il risultato dell'intera stagione.",
      seasonLabels: { adr: "ADR indicativo", occ: "Occupazione", days: "Giorni disponibili", result: "Ricavo stagionale indicativo" },
      cta: "Fammi un'analisi reale della mia casa",
    },
    caseStudy: {
      title: "Stessa casa. Strategia diversa.",
      big: "+521%",
      tag: "Caso studio specifico",
      text: "Nel periodo analizzato la struttura è passata da circa 6–7 notti vendute nel periodo comparabile dell'anno precedente a 28 notti vendute attraverso Airbnb.",
      note: "Il risultato riguarda questa struttura e non costituisce promessa di performance futura.",
      changed: "Cosa abbiamo cambiato",
      items: ["Strategia prezzi", "Annuncio", "Posizionamento", "Contenuti", "Distribuzione", "Gestione della disponibilità"],
      nightsBefore: "6–7 notti",
      nightsAfter: "28 notti",
      periodBefore: "Periodo comparabile, anno precedente",
      periodAfter: "Stesso periodo, con OGStay",
    },
    local: {
      eyebrow: "Tecnologia dove serve. Persone quando conta.",
      title: "Siamo qui.",
      p1: "OGStay è un team locale che vive l'Ogliastra ogni giorno.",
      p2: "Conosciamo il territorio, gli immobili e i professionisti con cui lavoriamo.",
      p3: "Quando serve un intervento, non risponde un call center a centinaia di chilometri.",
      depts: ["Revenue", "Guest Experience", "Housekeeping", "Property Care", "Marketing", "Administration"],
      closing: "Un unico ecosistema coordinato.",
    },
    portal: {
      title: "La casa è nostra responsabilità. I numeri restano tuoi.",
      demoTag: "Esempio illustrativo",
      stats: [
        { label: "Ricavi mese", value: "€4.820" },
        { label: "Occupazione", value: "78%" },
        { label: "ADR", value: "€146" },
        { label: "Prenotazioni", value: "21" },
      ],
      features: ["Calendario", "Prenotazioni", "Canali", "Incassi", "Commissioni", "Andamento", "Report", "Storico"],
      cta: "Accedi al portale proprietari",
    },
    tiers: {
      eyebrow: "Livelli di gestione",
      title: "Scegli quanto vuoi delegare.",
      more: "Vedi tutti i servizi",
      less: "Mostra meno",
      items: [
        {
          name: "Gestione Online",
          tagline: "Strategia e performance",
          desc: "Per proprietari che vogliono mantenere l'operatività locale ma affidare marketing, distribuzione e revenue.",
          price: "10% – 15%",
          priceNote: "commissione indicativa",
          points: ["Strategia di pricing dinamico", "Annunci ottimizzati", "Distribuzione multipiattaforma", "Consulenza operativa continuativa", "Analisi performance periodica"],
          extra: ["Restauro completo dell'annuncio (testi, struttura, immagini)", "Supporto comunicazione ospiti con template professionali", "Affiancamento strategico per rendimento e visibilità"],
          cta: "Richiedi informazioni",
        },
        {
          name: "Gestione Completa",
          badge: "Più completa",
          tagline: "Il tuo reparto hospitality esterno",
          desc: "Per chi vuole delegare l'intera operatività.",
          price: "20% – 25%",
          priceNote: "commissione indicativa",
          points: ["Annunci e distribuzione", "Pricing dinamico", "Gestione ospiti 24/7", "Pulizie e biancheria", "Check-in professionali", "Manutenzione ordinaria", "Report mensili"],
          extra: [],
          cta: "Richiedi la valutazione",
        },
        {
          name: "Gestione Su Misura · Villas",
          tagline: "Costruita intorno alla proprietà",
          desc: "Per ville, residence, immobili di pregio o configurazioni complesse.",
          price: "Su valutazione",
          priceNote: "in base al caso",
          points: ["Consulenza strategica dedicata", "Moduli attivabili su richiesta", "Flessibilità operativa", "Supporto personalizzato"],
          extra: [],
          cta: "Parliamone",
        },
      ],
      note: "Le condizioni economiche vengono definite dopo l'analisi dell'immobile, del livello di servizio e dell'operatività necessaria.",
    },
    select: {
      title: "Non cerchiamo il maggior numero possibile di immobili.",
      sub: "Cerchiamo le proprietà con cui possiamo fare un ottimo lavoro.",
      intro: "OGStay è adatto a te se:",
      items: [
        "Vuoi valorizzare realmente l'immobile",
        "Credi negli standard",
        "Vuoi ragionare sulla stagione",
        "Vuoi trasparenza",
        "Cerchi un partner, non solo un fornitore",
        "Vuoi costruire un'esperienza ospite migliore",
      ],
      cta: "Non sai se la tua proprietà è adatta? Scopriamolo insieme.",
    },
    faq: {
      title: "Domande frequenti",
      groups: [
        {
          label: "Gestione immobiliare",
          items: [
            { q: "Quanto costa la gestione?", a: "Una commissione indicativa tra il 10% e il 25%, in base al modello scelto. Le condizioni precise si definiscono dopo l'analisi gratuita dell'immobile." },
            { q: "Posso utilizzare personalmente la casa?", a: "Sì. Blocchi tu le date dal portale proprietari: la casa resta tua, sempre." },
            { q: "Chi gestisce gli ospiti?", a: "Nella gestione completa pensiamo a tutto noi: comunicazioni, check-in, assistenza durante il soggiorno. Nella gestione online la parte digitale e strategica è nostra, l'operatività si concorda per livello." },
            { q: "Chi si occupa delle pulizie?", a: "Le coordiniamo noi con team locali. Quando contratto e canale lo consentono, sono una voce di servizio addebitata all'ospite, separata dal canone." },
            { q: "Chi decide i prezzi?", a: "Li costruiamo insieme: strategia condivisa, poi ottimizzazione continua basata sui dati. Hai sempre visibilità totale." },
            { q: "Posso controllare prenotazioni e incassi?", a: "Sì, dal portale proprietari vedi calendario, prenotazioni, incassi e report in tempo reale." },
            { q: "Quanto dura l'accordo?", a: "Accordi flessibili, tipicamente stagionali o annuali, con condizioni e recesso definiti chiaramente nel contratto." },
          ],
        },
        {
          label: "Servizi singoli",
          items: [
            { q: "Posso acquistare un servizio senza affidare la gestione?", a: "Certo. I servizi OGStay sono acquistabili singolarmente, senza alcun vincolo di gestione." },
            { q: "I servizi sono disponibili in tutta Italia?", a: "Molti sì, anche da remoto: annunci, prezzi, consulenza, audit. Quelli in presenza — home staging, fotografia, makeover — dipendono dalla località e li valutiamo caso per caso." },
            { q: "Cosa comprende la chiamata gratuita?", a: "15 minuti insieme per capire la tua situazione e indicarti il percorso più adatto. Senza impegno." },
            { q: "Quanto tempo serve per ottimizzare un annuncio?", a: "Indicativamente 48–72 ore lavorative dalla ricezione di tutti i materiali." },
            { q: "Il costo dei materiali di home staging è incluso?", a: "No: compenso OGStay e materiali sono distinti, e gli oggetti acquistati per te restano di tua proprietà." },
            { q: "Posso richiedere fotografia e home staging insieme?", a: "Sì, è la combinazione ideale: nel Listing Makeover sono già integrati insieme all'ottimizzazione dell'annuncio." },
            { q: "Come funziona il Revenue Management mensile?", a: "Da 60 €/mese per immobile: monitoraggio della domanda, aggiornamento dei prezzi e supporto del revenue manager, secondo il piano concordato. Non equivale alla gestione completa." },
          ],
        },
      ],
    },
    reviews: {
      eyebrow: "Recensioni verificate",
      title: "Gli ospiti lo dicono meglio di noi.",
      sub: "Recensioni reali lasciate dagli ospiti sulle piattaforme di prenotazione.",
      verified: "Recensione verificata · Airbnb",
      items: [
        { name: "Silvia", from: "Oristano, Italia", date: "giugno 2025", quote: "L'alloggio di Enrico è stato perfetto per la nostra mini vacanza. Camera dotata di tutti i comfort, bagno grande con doccia super. Una nota di merito al materasso: veramente di qualità! Zona tranquilla con parcheggio interno comodo. Consigliato." },
        { name: "Jessica", from: "Stoccarda, Germania", date: "giugno 2025", quote: "Alloggio bello e nuovo con una grande veranda. Tutto super pulito. Ottima comunicazione con Enrico, sempre raggiungibile. Abbiamo anche prenotato un fantastico giro in barca tramite la sua collega. Lo consiglio vivamente!" },
        { name: "Jörg", from: "Germania", date: "settembre 2025", property: "Villa Libera · Terrazza Vista Mare & Jacuzzi", quote: "Un ambiente davvero bello, un giardino fantastico con vista sul mare e piscina, spiagge a 2 minuti a piedi. Enrico è stato disponibile e gentile, ha risposto a tutte le nostre domande dandoci consigli su cosa vedere. Un host perfetto: torneremo sicuramente!" },
        { name: "Angela", from: "Amburgo, Germania", date: "giugno 2025", quote: "Siamo stati accolti calorosamente. L'appartamento era incredibilmente pulito, si vede molto raramente. Il giardino è perfetto per i bambini piccoli. La spiaggia, a pochi passi, è bellissima e con mare calmo." },
        { name: "Ricardo", from: "Miami, Florida", date: "2025", quote: "Appartamento molto bello con tutto il necessario per un soggiorno fantastico. La zona è riservata e tranquilla. Enrico è stato un host eccellente ed è stato sempre attento." },
      ],
    },
    final: {
      title: "Parliamone: 15 minuti gratuiti.",
      sub: "Raccontaci la tua casa e cosa ti serve: ti ricontattiamo entro 24 ore per organizzare la chiamata conoscitiva. Senza impegno.",
      cta: "Inizia la mia analisi",
      trust: ["Gratuita", "Senza impegno", "Risposta entro 24 ore"],
    },
    form: {
      title: "Richiedi la tua valutazione gratuita",
      prefilled: "Precompilato dal tuo quiz",
      name: "Nome",
      namePh: "Maria",
      surname: "Cognome",
      surnamePh: "Piras",
      phone: "Telefono",
      phonePh: "+39 333 000 0000",
      email: "Email",
      emailPh: "maria@email.it",
      contactPref: "Dove preferisci essere ricontattato?",
      contactOpts: ["WhatsApp", "Telefono", "Email"],
      location: "Località immobile",
      locationPh: "Tortolì, Arbatax, Baunei…",
      type: "Tipologia",
      types: ["Appartamento", "Casa indipendente", "Villa", "Residence", "Struttura ricettiva", "B&B / Affittacamere", "Altro"],
      bedrooms: "Camere",
      bedroomsOpts: ["1", "2", "3", "4", "5+"],
      beds: "Posti letto",
      bedsOpts: ["2", "4", "6", "8", "10+"],
      online: "Già online?",
      onlineOpts: ["Sì", "No", "In parte"],
      link: "Link Airbnb / Booking (opzionale)",
      linkPh: "https://…",
      objective: "Qual è il tuo obiettivo?",
      objectiveOpts: ["Aumentare il rendimento", "Delegare la gestione", "Avviare una nuova struttura", "Migliorare una struttura già esistente", "Altro"],
      submit: "Richiedi la mia valutazione",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti risponderemo entro 24 ore con un'analisi dettagliata.",
      error: "Qualcosa non ha funzionato. Riprova tra poco.",
      progress: "Completamento",
      steps: ["Dove si trova l'immobile?", "Che tipo di proprietà è?", "Quante camere?", "È già online?", "I tuoi contatti"],
      step: "Passo",
      of: "di",
      back: "Indietro",
      next: "Continua",
      message: "Messaggio (opzionale)",
      messagePh: "Raccontaci qualcosa in più sulla tua proprietà…",
      required: "Campo obbligatorio",
      emailError: "Inserisci un indirizzo email valido",
      successTitle: "Grazie, richiesta ricevuta.",
      successBody: "Abbiamo ricevuto le informazioni sulla tua proprietà. Ti contatteremo per una prima analisi senza impegno.",
      successAgain: "Invia un'altra richiesta",
    },
    sticky: { text: "Parliamone: 15 minuti gratuiti", cta: "Contattaci" },
  },
  en: {
    seo: {
      title: "Professional short-let management in Ogliastra | OGStay",
      description:
        "Services for your holiday home: listing optimisation, home staging, photography, revenue management and full management in Ogliastra — many available remotely across Italy. Request a free valuation.",
    },
    hero: {
      eyebrow: "For owners",
      h1a: "Your home can earn more.",
      h1b: "Without becoming a second job.",
      sub: "We manage and enhance holiday homes in Ogliastra. And we put our experience at the service of owners across Italy through dedicated professional services.",
      lines: ["Real presence in Ogliastra.", "Total control.", "One team coordinating everything."],
      cta: "Entrust the management",
      ctaSecondary: "Explore individual services",
      trust: ["Free 15-minute introductory call", "No commitment"],
    },
    quiz: {
      title: "Let's start with your home.",
      sub: "Three questions, thirty seconds.",
      questions: [
        { q: "Where is your property?", options: ["Tortolì", "Arbatax", "Cardedu", "Bari Sardo", "Other"] },
        { q: "What kind of property is it?", options: ["Villa", "Detached house", "Apartment", "Residence", "Hospitality venue", "Other"] },
        { q: "Is it already online?", options: ["Yes", "No", "Partly"] },
      ],
      done: "Perfect. We already have the first insights to understand your property's potential.",
      cta: "Continue the valuation",
      step: "Question",
    },
    pains: {
      title: "A holiday home can no longer be managed in your spare time.",
      items: [
        { tag: "Pricing", headline: "How much are you losing on the wrong days?", text: "A rate too high leaves gaps. Too low gives margin away." },
        { tag: "Guests", headline: "Who answers at 11:40 pm?", text: "Requests, issues, reviews and surprises don't follow office hours." },
        { tag: "Operations", headline: "Who checks everything is truly ready?", text: "Cleaning, laundry, maintenance, amenities and check-in must work as one system." },
        { tag: "Compliance", headline: "Are you sure the setup is correct?", text: "Classification, CIN, guests, tourist tax, documents and procedures all require attention." },
      ],
      closing: "OGStay coordinates all of this as one system.",
    },
    method: {
      eyebrow: "The OGStay method",
      title: "We don't simply take a house into management.",
      titleItalic: "We build a hospitality product.",
      steps: [
        { n: "01", t: "We analyse", items: ["property", "area", "competition", "demand", "target", "potential"] },
        { n: "02", t: "We enhance", items: ["home staging", "amenities", "comfort", "layout", "presentation"] },
        { n: "03", t: "We position", items: ["photography", "copywriting", "listings", "channels", "branding"] },
        { n: "04", t: "We sell", items: ["revenue management", "dynamic pricing", "occupancy", "restrictions", "distribution"] },
        { n: "05", t: "We manage", items: ["guests", "housekeeping", "check-in", "maintenance", "assistance"] },
        { n: "06", t: "We measure", items: ["ADR", "occupancy", "revenue", "performance", "reports", "optimisation"] },
      ],
    },
    hotel: {
      eyebrow: "High hôtellerie, private home",
      title: "The freedom of a home. The standards of a grand hotel.",
      text: "We don't want to turn a home into a hotel. We take from hôtellerie what truly makes the difference: standards, procedures, comfort, care and attention to detail.",
      standards: [
        { t: "Sleep", d: "Mattresses, pillows, linen and comfort." },
        { t: "Clean", d: "Housekeeping and quality control." },
        { t: "Welcome", d: "First impact, amenities and preparation." },
        { t: "Design", d: "Visual order and perceived value." },
        { t: "Care", d: "Maintenance and property protection." },
        { t: "Guest", d: "Assistance and customer experience." },
      ],
      closing: "Quality homes attract quality guests.",
    },
    staging: {
      title: "You don't need to spend much. You need to invest in the right details.",
      text1: "We analyse what truly increases the perceived value of the property.",
      text2: "We don't fill rooms with furniture. We select a few high-impact interventions on comfort, photography and desirability.",
      highlight: "Few interventions. Well chosen. High impact.",
      before: "Before",
      after: "After",
      demo: "A real OGStay project · home staging and enhancement",
    },
    buro: {
      eyebrow: "From property to a structure ready to work",
      title: "You have the home. We build the system around it.",
      text: "We support you with the start-up and operational setup of your structure, based on its classification.",
      items: [
        "Initial situation analysis",
        "Support with correct classification",
        "CIN",
        "PMS configuration",
        "Guest Portal",
        "Institutional portals",
        "Guest registration",
        "ISTAT flows",
        "Tourist tax",
        "Contracts",
        "Airbnb and Booking",
        "Channel manager",
        "Automations",
        "Owner portal",
      ],
      note: "Requirements vary depending on the type of structure and the owner's situation.",
      cta: "Check your structure's setup",
    },
    mandate: {
      eyebrow: "A structured management model",
      title: "It's not just how much the house earns. It's how much stays with the owner.",
      p1: "OGStay can operate through a mandate with representation, with transparent handling of the different economic components of each booking.",
      p2: "When the contract, sales channel and fiscal framework allow it, some service items can be managed separately from the rental fee and charged directly to the guest.",
      highlight: "More transparency. Fewer inefficiencies. Greater attention to the net result.",
      note: "Every fiscal situation is analysed individually. Simulations are for information purposes and must be validated on your specific case with your tax advisor.",
    },
    calc: {
      title: "What is a booking really worth?",
      stay: "Stay value",
      cleaning: "Cleaning",
      channel: "Channel",
      channels: ["Airbnb", "Booking", "Direct"],
      tax: "Indicative tax rate",
      mgmt: "Management fee",
      traditional: "Traditional management",
      ogstay: "OGStay model",
      rows: {
        guest: "Guest payment",
        ota: "Channel fee",
        cleaning: "Cleaning",
        mgmt: "Management",
        base: "Indicative taxable base",
        tax: "Estimated taxes",
        net: "Indicative net",
      },
      disclaimer: "Simulation for information purposes only, not a fiscal calculation. Every case must be validated with your advisor.",
      seasonIntro: "But a single booking tells only part of the story.",
      seasonFormula: "ADR × occupancy × available days",
      seasonNote: "The real goal is to maximise the result of the whole season.",
      seasonLabels: { adr: "Indicative ADR", occ: "Occupancy", days: "Available days", result: "Indicative seasonal revenue" },
      cta: "Get a real analysis of my home",
    },
    caseStudy: {
      title: "Same house. Different strategy.",
      big: "+521%",
      tag: "Specific case study",
      text: "In the analysed period, the structure went from about 6–7 nights sold in the comparable period of the previous year to 28 nights sold through Airbnb.",
      note: "This result concerns this specific property and is not a promise of future performance.",
      changed: "What we changed",
      items: ["Pricing strategy", "Listing", "Positioning", "Content", "Distribution", "Availability management"],
      nightsBefore: "6–7 nights",
      nightsAfter: "28 nights",
      periodBefore: "Comparable period, previous year",
      periodAfter: "Same period, with OGStay",
    },
    local: {
      eyebrow: "Technology where it helps. People where it matters.",
      title: "We are here.",
      p1: "OGStay is a local team that lives Ogliastra every day.",
      p2: "We know the territory, the properties and the professionals we work with.",
      p3: "When something needs fixing, you don't get a call centre hundreds of kilometres away.",
      depts: ["Revenue", "Guest Experience", "Housekeeping", "Property Care", "Marketing", "Administration"],
      closing: "One coordinated ecosystem.",
    },
    portal: {
      title: "The home is our responsibility. The numbers stay yours.",
      demoTag: "Illustrative example",
      stats: [
        { label: "Monthly revenue", value: "€4,820" },
        { label: "Occupancy", value: "78%" },
        { label: "ADR", value: "€146" },
        { label: "Bookings", value: "21" },
      ],
      features: ["Calendar", "Bookings", "Channels", "Earnings", "Fees", "Trends", "Reports", "History"],
      cta: "Go to the owner portal",
    },
    tiers: {
      eyebrow: "Management levels",
      title: "Choose how much you want to delegate.",
      more: "See all services",
      less: "Show less",
      items: [
        {
          name: "Online Management",
          tagline: "Strategy and performance",
          desc: "For owners who keep local operations but delegate marketing, distribution and revenue.",
          price: "10% – 15%",
          priceNote: "indicative fee",
          points: ["Dynamic pricing strategy", "Optimised listings", "Multi-platform distribution", "Ongoing operational consulting", "Periodic performance analysis"],
          extra: ["Complete listing makeover (copy, structure, imagery)", "Guest communication support with professional templates", "Strategic support for revenue and visibility"],
          cta: "Request information",
        },
        {
          name: "Full Management",
          badge: "Most complete",
          tagline: "Your external hospitality department",
          desc: "For those who want to delegate all operations.",
          price: "20% – 25%",
          priceNote: "indicative fee",
          points: ["Listings and distribution", "Dynamic pricing", "24/7 guest management", "Cleaning and linen", "Professional check-ins", "Ordinary maintenance", "Monthly reports"],
          extra: [],
          cta: "Request the valuation",
        },
        {
          name: "Tailored Management · Villas",
          tagline: "Built around the property",
          desc: "For villas, residences, prestigious properties or complex configurations.",
          price: "On valuation",
          priceNote: "based on the case",
          points: ["Dedicated strategic consulting", "Modules activated on request", "Operational flexibility", "Personalised support"],
          extra: [],
          cta: "Let's talk",
        },
      ],
      note: "Economic terms are defined after analysing the property, the level of service and the operations required.",
    },
    select: {
      title: "We're not looking for the highest possible number of properties.",
      sub: "We're looking for the properties with which we can do an excellent job.",
      intro: "OGStay is right for you if:",
      items: [
        "You want to truly enhance your property",
        "You believe in standards",
        "You want to think in seasons",
        "You want transparency",
        "You're looking for a partner, not just a supplier",
        "You want to build a better guest experience",
      ],
      cta: "Not sure if your property is right? Let's find out together.",
    },
    faq: {
      title: "Frequently asked questions",
      groups: [
        {
          label: "Property management",
          items: [
            { q: "How much does management cost?", a: "An indicative fee between 10% and 25%, depending on the chosen model. Exact terms are defined after the free property analysis." },
            { q: "Can I use the house personally?", a: "Yes. You block the dates yourself from the owner portal: the home stays yours, always." },
            { q: "Who handles the guests?", a: "With full management we take care of everything: communications, check-in, assistance during the stay. With online management, the digital and strategic side is ours; operations are agreed by level." },
            { q: "Who takes care of cleaning?", a: "We coordinate it with local teams. When contract and channel allow it, cleaning is a service item charged to the guest, separate from the rental fee." },
            { q: "Who sets the prices?", a: "We build them together: shared strategy, then continuous data-driven optimisation. You always have full visibility." },
            { q: "Can I control bookings and earnings?", a: "Yes, from the owner portal you see calendar, bookings, earnings and reports in real time." },
            { q: "How long does the agreement last?", a: "Flexible agreements, typically seasonal or annual, with terms and termination clearly defined in the contract." },
          ],
        },
        {
          label: "Individual services",
          items: [
            { q: "Can I buy a service without handing over management?", a: "Of course. OGStay services can be purchased individually, with no management commitment." },
            { q: "Are the services available across Italy?", a: "Many are, also remotely: listings, pricing, consulting, audits. On-site services — home staging, photography, makeover — depend on the location and are assessed case by case." },
            { q: "What does the free call include?", a: "15 minutes together to understand your situation and point you to the most suitable path. No commitment." },
            { q: "How long does listing optimisation take?", a: "Indicatively 48–72 working hours from receiving all materials." },
            { q: "Is the cost of home-staging materials included?", a: "No: OGStay's fee and materials are separate, and items purchased for you remain your property." },
            { q: "Can I request photography and home staging together?", a: "Yes, it's the ideal combination: in the Listing Makeover they are already integrated with listing optimisation." },
            { q: "How does monthly Revenue Management work?", a: "From €60/month per property: demand monitoring, price updates and revenue manager support, according to the agreed plan. It is not equivalent to full management." },
          ],
        },
      ],
    },
    reviews: {
      eyebrow: "Verified reviews",
      title: "Guests say it better than we do.",
      sub: "Real reviews left by guests on booking platforms, shown in their original language.",
      verified: "Verified review · Airbnb",
      items: [
        { name: "Silvia", from: "Oristano, Italy", date: "June 2025", quote: "L'alloggio di Enrico è stato perfetto per la nostra mini vacanza. Camera dotata di tutti i comfort, bagno grande con doccia super. Una nota di merito al materasso: veramente di qualità! Zona tranquilla con parcheggio interno comodo. Consigliato." },
        { name: "Jessica", from: "Stuttgart, Germany", date: "June 2025", quote: "Alloggio bello e nuovo con una grande veranda. Tutto super pulito. Ottima comunicazione con Enrico, sempre raggiungibile. Abbiamo anche prenotato un fantastico giro in barca tramite la sua collega. Lo consiglio vivamente!" },
        { name: "Jörg", from: "Germany", date: "September 2025", property: "Villa Libera · Terrazza Vista Mare & Jacuzzi", quote: "Un ambiente davvero bello, un giardino fantastico con vista sul mare e piscina, spiagge a 2 minuti a piedi. Enrico è stato disponibile e gentile, ha risposto a tutte le nostre domande dandoci consigli su cosa vedere. Un host perfetto: torneremo sicuramente!" },
        { name: "Angela", from: "Hamburg, Germany", date: "June 2025", quote: "Siamo stati accolti calorosamente. L'appartamento era incredibilmente pulito, si vede molto raramente. Il giardino è perfetto per i bambini piccoli. La spiaggia, a pochi passi, è bellissima e con mare calmo." },
        { name: "Ricardo", from: "Miami, Florida", date: "2025", quote: "Appartamento molto bello con tutto il necessario per un soggiorno fantastico. La zona è riservata e tranquilla. Enrico è stato un host eccellente ed è stato sempre attento." },
      ],
    },
    final: {
      title: "Let's talk: 15 free minutes.",
      sub: "Tell us about your home and what you need: we'll get back to you within 24 hours to arrange the introductory call. No commitment.",
      cta: "Start my analysis",
      trust: ["Free", "No commitment", "Reply within 24 hours"],
    },
    form: {
      title: "Request your free valuation",
      prefilled: "Prefilled from your quiz",
      name: "First name",
      namePh: "Maria",
      surname: "Last name",
      surnamePh: "Piras",
      phone: "Phone",
      phonePh: "+39 333 000 0000",
      email: "Email",
      emailPh: "maria@email.com",
      contactPref: "Where do you prefer to be contacted?",
      contactOpts: ["WhatsApp", "Phone", "Email"],
      location: "Property location",
      locationPh: "Tortolì, Arbatax, Baunei…",
      type: "Property type",
      types: ["Apartment", "Detached house", "Villa", "Residence", "Hospitality venue", "B&B / Guesthouse", "Other"],
      bedrooms: "Bedrooms",
      bedroomsOpts: ["1", "2", "3", "4", "5+"],
      beds: "Beds",
      bedsOpts: ["2", "4", "6", "8", "10+"],
      online: "Already online?",
      onlineOpts: ["Yes", "No", "Partly"],
      link: "Airbnb / Booking link (optional)",
      linkPh: "https://…",
      objective: "What is your goal?",
      objectiveOpts: ["Increase revenue", "Delegate management", "Launch a new structure", "Improve an existing structure", "Other"],
      submit: "Request my valuation",
      sending: "Sending…",
      success: "Request sent. We'll reply within 24 hours with a detailed analysis.",
      error: "Something went wrong. Please try again shortly.",
      progress: "Completion",
      steps: ["Where is the property?", "What type of property is it?", "How many bedrooms?", "Is it already online?", "Your contact details"],
      step: "Step",
      of: "of",
      back: "Back",
      next: "Continue",
      message: "Message (optional)",
      messagePh: "Tell us something more about your property…",
      required: "Required field",
      emailError: "Enter a valid email address",
      successTitle: "Thank you, request received.",
      successBody: "We have received the information about your property. We will contact you for a first, no-obligation analysis.",
      successAgain: "Send another request",
    },
    sticky: { text: "Let's talk: 15 free minutes", cta: "Contact us" },
  },
};
